import styled from 'styled-components';

export const RangeContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const Slider = styled.input`
  position: absolute;
  pointer-events: none;
  width: 100%;
  -webkit-appearance: none;
  background: transparent;

  &::-webkit-slider-thumb {
    pointer-events: all;
    width: 34px;
    height: 20px;
    margin-top: -11px;
    background: var(--brand-main);
    cursor: grab;
    -webkit-appearance: none;
    z-index: 2;
    position: relative;
    transform: translate3d(0, 0, 0);
    border-radius: 29px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.15);

    &:hover {
      border: 1px solid var(--textAndLabels-main);
    }
  }

  &::-webkit-slider-runnable-track {
    height: 1px;
    border-radius: 5px;
    background-color: transparent;
  }
`;

export const Track = styled.div<{ $isActive: boolean; $width: string }>`
  position: absolute;
  top: -2px;
  left: 10px;
  width: calc(100% - 10px);
  height: 2px;
  background-color: ${({ $isActive }) =>
    $isActive ? 'var(--textAndLabels-main)' : 'transparent'};
  border-radius: 2px;
  z-index: 1;
  pointer-events: none;
  transition: background-color 0.3s ease;
  transform-origin: left;
  transform: scaleX(${({ $width }) => $width});
  will-change: transform;
`;
